import React, { useState, useEffect } from "react";
import Template from "../../../components/Template";
import _ from "lodash";
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
  Card,
  CardHeader,
  CardContent,
  Tab,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../../components/Button";
import Snackbar from "../../../components/Snackbar";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "../../common.css";
import useToken from "../../../hooks/useToken";
import {
  createAttachment,
  getCertificationDetailsList,
  getMrindocumentdownload,
  getcertificatedetails,
  getcertificationbodycreate,
  getcertificationcreate,
  getDocumentsDownload,
  getUploadDocument,
  getretrivenotes,
  getcreateattachment,
  getretriveAttachment,
  getretriveAuditlog,
} from "../../../apis"; //getMRINDetail
import SimpleModal from "../../../components/Modal";
import BasicTable from "../../../components/BasicTable";
import { colors } from "../../../constants/colors";
import roles from "../../../constants/roles";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import moment from "moment-timezone";
import { routeBuilder } from "../../../utils/routeBuilder";
import ContentTabs from "../../../components/ContentTabs";
import config from "../../../constants/config";
import NoteList from "../../../utils/noteList";
import S3 from "react-aws-s3";
import AWS from "aws-sdk";
import FileSaver from "file-saver";
import { Button as AButton } from "@material-ui/core";
import FiltersTable from "../../../components/FiltersTable";
import AuditLog from "./AuditLog";
import ViewAuditLog from "./ViewAuditLog";
import { commonStrings, certificationStrings, attachmentsStrings } from "../../../components/StringBundle";


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiFormControl-fullWidth": {
      width: "95%",
    },
    "& .MuiGrid-grid-sm-5 .MuiFormControl-fullWidth": {
      width: "100%",
    },
    "& .page-header": {
      width: "100%",
      marginBottom: 15,
    },
    "& .MuiAccordion-root": {
      width: "100%",
    },
    "& .MuiPaper-rounded": {
      width: "100%",
    },
    "& .dispatchTable": {
      maxHeight: "400px",
      overflowY: "auto",
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  modal: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "auto",
    top: "50%",
    right: "50%",
    transform: "translate(50%, -50%)",
    width: 1000,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #fefefe",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "scroll",
    maxHeight: "90vh",
    maxWidth: "90vw",
  },
  modal1: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "auto",
    top: "50%",
    right: "50%",
    transform: "translate(50%, -50%)",
    width: 600,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #fefefe",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "scroll",
    maxHeight: "90vh",
    maxWidth: "90vw",
  },
  otherModal: {
    marginTop: "8px",
    marginBottom: "8px",
  },
  button: {
    margin: theme.spacing(1),
    backgroundColor: colors.orange,
    color: colors.white,
    minWidth: 50,
    textTransform: "capitalize",

    "&:hover": {
      backgroundColor: colors.orange,
      opacity: 0.8,
    },
    "& $MuiButton-label": {
      margin: 0,
    },
  },
}));

let status = [
  { status: "ACTIVE" },
  { status: "INITIATED" },
  { status: "AUDIT COMPLETE" },
];
const formatDate = (datestr) => {
  let dateVal = new Date(datestr);
  return (
    dateVal.getFullYear() +
    "-" +
    (dateVal.getMonth() + 1) +
    "-" +
    dateVal.getDate()
  );
};

const ViewCertification = (props) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const { getCurrentUserDetails } = useToken();
  const currentUserDetails = getCurrentUserDetails();
  const { certificationId } = useParams();
  const [notes, setNotes] = useState([]);
  const [certificationDetails, setCertificationDetails] = useState({});
  const [locationList, setLocationList] = useState([]);
  const [certificationList, setcertificationList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [showSnack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const role = currentUserDetails.role;
  const [searchParams] = useSearchParams();
  const tabId = searchParams.get("tab") || "details";
  const [disableInvoice, setDisableInvoice] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState({});
  const [disableCreate, setDisableCreate] = useState(false);
  const [uploadedFile, setUploadedFile] = useState({});
  const certificationView = certificationStrings.view;
  const certificationSections = certificationStrings.sections;

  const [openAddCertificationBody, setOpenAddCertificationBody] = useState(false);
  const [attachments, setAttachments] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const rows = [];
  const [disableUploadBtn, setDisableUploadBtn] = useState(true);
  const [allData, setAllData] = useState([]);
  const [auditLogs, setAuditlogs] = useState([]);
  const [logData, setLogData] = useState([]);
  const antColumns = [
    {
      title: commonStrings.fileName,
      dataIndex: "name",
      key: "name",
      width: "20%",
      render: (text, record) => (
        <a onClick={() => handleDownload(record)}>{text}</a>
      ),
    },
    {
      title: commonStrings.uri,
      dataIndex: "uri",
      key: "uri",
      width: "20%",
    },
    {
      title: commonStrings.createdBy,
      dataIndex: "createdBy",
      key: "createdBy",
      width: "15%",
    },
    {
      title: commonStrings.createdDate,
      dataIndex: "createdAt",
      key: "createdAt",
      width: "15%",
    },
  ];
  window.Buffer = window.Buffer || require("buffer").Buffer;

  useEffect(async () => {
    fetchData();

    getretrivenotes(certificationId).then((noteRes) => {
      setNotes(noteRes);
    });
    retrieveAttachments();
    fetchAuditLogs()
  }, []);

  const retrieveAttachments = async () => {
    const data =  certificationId ;
    try {
      let response = await getretriveAttachment(data);
      console.log("Response", response);
      if (response?.length > 0) {
        response.map((v) => {
          rows.push(
            createData(v.name, v.uri, v.createdBy, formatDate(v.createdAt))
          );
        });
        setAllData(rows);
        setAttachments(response);
        console.log(attachments);
      }
    } catch (e) {
      setSnack({
        open: true,
        message: commonStrings.serverError, //e.response?.data
        severity: commonStrings.error,
      });
    }
  };
  const fetchAuditLogs = async () => {
    const data =  certificationId 
    try {
      let response = await getretriveAuditlog(data);
      console.log("Response", response);
      if (response?.length > 0) {
        // let auditRes = response.map(item => {
        //   let field = item.field
        //   if (field.split(" ").length > 1) {
        //     if (typeof field == "string" && field.indexOf("-") === -1) {
        //       field = field.charAt(0).toUpperCase() + field.slice(1);
        //       field = field.replace(/Lr |Pr |Oe |Ne |Au |Cp |Dp |Ep |Sd |Sa |Do |Ops |Fd 1 |Gc |Fd 2 |Ps |Pc |Rg/, "");
        //       item.field = field
        //     }
        //   } else {
        //     if (typeof field == "string" && field.indexOf("-") === -1) {
        //       field = field.charAt(0).toUpperCase() + field.slice(1);
        //       field = field.match(/[A-Z][a-z]+|[0-9]+/g).join(" ")
        //       field = field.replace(/Lr |Pr |Oe |Ne |Au |Cp |Dp |Ep |Sd |Sa |Do |Ops |Fd 1 |Gc |Fd 2 |Ps |Pc |Rg/, "");
        //       item.field = field
        //     }
        //   }
        //   return item;
        // })
        let auditRes = response.map(item => {
          let field = item.field
          if (typeof field == "string") {
            field = field.replaceAll('_', " ");
            item.field = field
          }
          return item;
        })
        setAuditlogs(auditRes);
      }
    } catch (e) {
      setSnack({
        open: true,
        message: commonStrings.serverError,
        severity: commonStrings.error,
      })
    }
  }

  async function fetchData() {
    try {
      let response = await getCertificationDetailsList();
      if (response) {
        setLocationList(
          response?.loaction_details === null ? [] : response?.loaction_details
        );
        setcertificationList(
          response?.certification_list === null
            ? []
            : response?.certification_list
        );
        setCountryList(
          response?.country_list === null ? [] : response?.country_list
        );
      }
    } catch (e) {
      setSnack({
        open: true,
        message: commonStrings.serverError, //e.response?.data
        severity: commonStrings.error,
      });
    }

    await fetchViewData();

  }

  const fetchViewData = async () => {
    try {
      let response = await getcertificatedetails(certificationId);
      if (response) {
        let data = response?.certification_info[0];
        setCertificationDetails(data);
        setUploadedFile({ name: data?.doc_name });
        setLogData([{description:'Certification', created_user_id: data?.created_by, created_date: formatDatenew(data?.created_date), modified_user_id: data?.modified_by, modified_date: formatDatenew(data?.modified_date) }])
      }
    } catch (e) {
      setSnack({
        open: true,
        message: commonStrings.serverError, //e.response?.data
        severity: commonStrings.error,
      });
    }
  }

  const handleChange = (val, key) => {
    setCertificationDetails({
      ...certificationDetails,
      [key]: val,
    });
  };

  const handleChangeLocation = (event, value) => {
    setCertificationDetails({
      ...certificationDetails,
      location: value,
    });
  };

  const handleChangeCountry = (event, value) => {
    setCertificationDetails({
      ...certificationDetails,
      country: value,
    });
  };

  const handleChangestatus = (event, value) => {
    setCertificationDetails({
      ...certificationDetails,
      status: value,
    });
  };
  const handleChangeBody = (event, value) => {
    setCertificationDetails({
      ...certificationDetails,
      certificationBody: value,
    });
  };

  const handleDateChange = (date, key) => {
    if (key === 'expiry_date') {
      let temp = {};
      temp = {
        ...certificationDetails,
        [key]: date,
        alert_initation_date1: convertDateintoTZ(new Date(new Date(date).setDate(new Date(date).getDate() - 60))),
        alert_initation_date2: convertDateintoTZ(new Date(new Date(date).setDate(new Date(date).getDate() - 30))),
      };
      console.log('temp:44', temp, date)
      setCertificationDetails(temp);
    } else {
      setCertificationDetails({
        ...certificationDetails,
        [key]: date,
      });
    }

  };
  // const formatDate = (datestr) => {
  //   console.log("dateVal::",datestr, new Date(datestr))
  //   let dateVal = new Date(datestr);
    
  //   return (
  //     dateVal.getDate() +
  //     "-" +
  //     (dateVal.getMonth() + 1) +
  //     "-" +
  //     dateVal.getFullYear()
  //   );
  // };
  const formatDatenew = (datestr) => {
  let dateVal = datestr ? new Date(datestr) : new Date();
  return (
    dateVal.getFullYear() +
    "-" +
    String(dateVal.getMonth() + 1).padStart(2, '0') +
    "-" +
    String(dateVal.getDate()).padStart(2, '0')
  );
};
  function bytesToMegaBytes(bytes) {
    return bytes / (1024 * 1024);
  }
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  function convertDateintoTZ(dt) {
    var currentimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return moment(dt).tz(currentimeZone).format()
  }

  async function CerificationAction(e) {
    // e.preventDefault();

    const message = "Please enter valid details";
    let errorObj = {};
    if (_.isEmpty(certificationDetails.certification_name)) {
      errorObj = { ...errorObj, certification_name: message };
    }
    if (_.isEmpty(certificationDetails.country)) {
      errorObj = { ...errorObj, country: message };
    }


    setValidationError(errorObj);
    // if (!_.isEmpty(errorObj)) {
    //   setValidationError(errorObj);
    // }
    if (!_.isEmpty(errorObj)) {
      try {
        setValidationError(errorObj);
        const errorMessage = { message: "Please fill all mandatory fields" };
        throw errorMessage;
      } catch (err) {
        setSnack({
          open: true,
          message: "please fill the required field",
          //  err.response?.data,
          severity: "error",
        });
      }
    } else {
      setLoading(true);
      setDisableCreate(true);
    }
    let data = {
      certification_name: certificationDetails.certification_name,
      country: certificationDetails.country?.country_name,
      created_by: currentUserDetails.id,
    };
    console.log("dataaa::", data);
    try {
      let response = await getcertificationbodycreate(data);
      if (response) {
        setSnack({
          open: true,
          message: "Certification Body Added Successfully",
        });
        await fetchData();
        setOpenAddCertificationBody(!openAddCertificationBody);
        let temp = { ...certificationDetails };
        delete temp.country;
        delete temp.certification_name;
        setCertificationDetails(temp);
      }
    } catch (e) {
      setSnack({
        open: true,
        message: "Server Error. Please contact administrator", //e.response?.data
        severity: "error",
      });
    } finally {
      setLoading(false);
    }


  }

  async function CertificationCancel() {
    let temp = { ...certificationDetails };
    delete temp.country;
    delete temp.certification_name;
    setCertificationDetails(temp);
    setOpenAddCertificationBody(!openAddCertificationBody);
  }

  const payload1 = [
    {
      value: certificationView.location,
      type: "label",
      bold: true,
      sm: 6,
      lg: 6,
    },
    {
      type: "label",
      value: certificationDetails.location,
      sm: 6,
      lg: 6,
    },
    {
      value: certificationView.certification_body,
      type: "label",
      bold: true,
      sm: 6,
      lg: 6,
    },
    {
      type: "label",
      value: certificationDetails?.certification_name,
      sm: 6,
      lg: 6,
    },
    {
      value: certificationView.comments,
      type: "label",
      bold: true,
      sm: 6,
      lg: 6,
    },
    {
      type: "label",
      value: certificationDetails.comments,
      sm: 6,
      lg: 6,
    },
  ];
  const payload2 = [
    {
      value: certificationView.type_of_certification,
      type: "label",
      bold: true,
      sm: 6,
      lg: 6,
    },
    {
      type: "label",
      value: certificationDetails.type_of_certification,
      sm: 6,
      lg: 6,
    },
    {
      value: certificationView.status,
      type: "label",
      bold: true,
      sm: 6,
      lg: 6,
    },
    {
      type: "label",
      value: certificationDetails.status,
      sm: 6,
      lg: 6,
    },
  ];
  const payload3 = [
    {
      value: certificationView.issued_date,
      type: "label",
      bold: true,
      sm: 6,
      lg: 6,
    },
    {
      type: "label",
      value: formatDate(certificationDetails.issued_date),
      sm: 6,
      lg: 6,
    },
    {
      value: certificationView.next_audit_date,
      type: "label",
      bold: true,
      sm: 6,
      lg: 6,
    },
    {
      type: "label",
      value: formatDate(certificationDetails.next_audit_date),
      sm: 6,
      lg: 6,
    },
  ];
  const payload5 = [
    {
      value: certificationView.expiry_date,
      type: "label",
      bold: true,
      sm: 6,
      lg: 6,
    },
    {
      type: "label",
      value: formatDate(certificationDetails.expiry_date),
      sm: 6,
      lg: 6,
    },
    {
      value: certificationView.alert_initation_date,
      type: "label",
      bold: true,
      sm: 6,
      lg: 6,
    },
    {
      type: "label",
      value: formatDate(certificationDetails.alert_initation_date1),
      sm: 6,
      lg: 6,
    },
  ];

  async function handleDownloadDoc() {
    try {
      let response = await getMrindocumentdownload(certificationDetails.file_name);
      if (response) {
        const baseSrc = `data:application/pdf;base64,${response.fileData}`;
        const link = document.createElement("a");
        link.href = baseSrc;
        link.download = response.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (e) {
      console.log("ENTENDA O ERRO", e);

      setSnack({
        open: true,
        message: commonStrings.serverError, //e.response?.data
        severity: commonStrings.error,
      });
    }
  }

  const payload6 = [
    {
      value: certificationView.doc_name,
      type: "label",
      bold: true,
      sm: 3,
      lg: 3,
    },
    {
      type: "label",
      value: certificationDetails.doc_name,
      sm: 3,
      lg: 3,
    },
    {
      type: "button",
      label: certificationView.download,
      onClick: handleDownloadDoc,
      sm: 3,
      lg: 3,
    },
  ];
  const CreateCertifications = async (e) => {
    e.preventDefault();

    const message = "Please enter valid details";
    let errorObj = {};
    if (_.isEmpty(certificationDetails.type)) {
      errorObj = { ...errorObj, type: message };
    }
    if (_.isEmpty(certificationDetails.location)) {
      errorObj = { ...errorObj, location: message };
    }
    if (_.isEmpty(certificationDetails.certificationBody)) {
      errorObj = { ...errorObj, certificationBody: message };
    }
    if (_.isEmpty(certificationDetails.issued_date)) {
      errorObj = { ...errorObj, issued_date: message };
    }
    if (_.isEmpty(certificationDetails.expiry_date)) {
      errorObj = { ...errorObj, expiry_date: message };
    }
    if (_.isEmpty(certificationDetails.status)) {
      errorObj = { ...errorObj, status: message };
    }
    if (_.isEmpty(certificationDetails.next_audit_date)) {
      errorObj = { ...errorObj, next_audit_date: message };
    }
    if (_.isEmpty(uploadedFile)) {
      errorObj = { ...errorObj, uploadedFile: message };
    }

    setValidationError(errorObj);
    // if (!_.isEmpty(errorObj)) {
    //   setValidationError(errorObj);
    // }
    if (!_.isEmpty(errorObj)) {
      // try {
      //   setValidationError(errorObj);
      //   console.log("errorObj::", errorObj)
      //   const errorMessage = { message: "Please fill all mandatory fields" };
      //   throw errorMessage;
      // } catch (err) {
      setSnack({
        open: true,
        message: "Please fill mandatory fields to save",
        severity: "error",
      });
      // }
    } else {
      setLoading(true);
      let data = {
        location: certificationDetails.location?.entityname,
        type_of_certification: certificationDetails.type,
        certification_name: certificationDetails.certificationBody?.certification_name,
        cert_body_id: certificationDetails.certificationBody?.cert_body_id,
        status: certificationDetails.status?.status,
        comments: certificationDetails.comments,
        issued_date: formatDate(convertDateintoTZ(new Date(certificationDetails.issued_date))),
        expiry_date: formatDate(convertDateintoTZ(new Date(certificationDetails.expiry_date))),
        next_audit_date: formatDate(convertDateintoTZ(new Date(certificationDetails.next_audit_date))),
        alert_initation_date1: formatDate(convertDateintoTZ(new Date(certificationDetails.alert_initation_date1))),
        alert_initation_date2: formatDate(convertDateintoTZ(new Date(certificationDetails.alert_initation_date2))),
        fileContent: uploadedFile?.file,
        created_by: currentUserDetails.id,
        doc_name: uploadedFile?.name
      };
      console.log("dataa::", data, certificationDetails);

      try {
        let response = await getcertificationcreate(data);
        if (response) {
          setSnack({
            open: true,
            message: "Certificate Created Successfully",
          });
          // setGcDetails({});
          setTimeout(() => {
            navigate(`/certification`);
          }, 1500);
        }
      } catch (e) {
        setSnack({
          open: true,
          message: "Server Error. Please contact administrator", //e.response?.data
          severity: "error",
        });
      } finally {
        setLoading(false);
      }

      setDisableCreate(true);
    }
  };

  const handleFileInput = (e) => {
    let exitingAttachmentsLength = attachments?.filter(
      (x) => x.name === e.target.files[0].name
    ).length;
    if (exitingAttachmentsLength > 0) {
      setSnack({
        open: true,
        message: commonStrings.fileExistError,
        severity: commonStrings.error,
      });
    } else {
      setSelectedFile(e.target.files[0]);
      setDisableUploadBtn(false);
      e.target.value = null;
    }
  };
  function createData(name, uri, createdBy, createdAt) {
    return {
      name,
      uri,
      createdBy,
      createdAt,
    };
  }
 

  const uploadFile = async (file) => {
    console.log(file);
    console.log(config);
    setDisableUploadBtn(true);
    const allowedExt = [
      "jpg",
      "jpeg",
      "png",
      "bmp",
      "webp",
      "pdf",
      "xlsx",
      "xls",
    ];
    let files = await toBase64(file);
    files = files.replace(/^data:[^;]+;base64,/, "");
    const fileExtension = file.name.split(".").pop();
    const uri=`${config.dirName}/${file.name}`
    console.log("checking the data of the file",fileExtension,file,"fffffffffffff",uri,files);
    const payload={
      document_name:uri,
      file_content:files
    }
    getUploadDocument(payload)
      .then((res) => {
        if(res){
          
        
        console.log("Checking the data of the response",res);
        const payload = {
          parentId: certificationId,
          createdBy: currentUserDetails.name,
          name: file.name,
          uri: `${config.dirName}/${file.name}`,
        };
        getcreateattachment(payload)
          .then((res) => {
            res?.map((v) => {
              rows.push(
                createData(
                  v.name,
                  v.uri,
                  v.createdBy,
                  formatDate(v.createdAt)
                )
              );
            });

            setAllData(rows);
            setAttachments(res);
            setSelectedFile(null);
          })
          .catch((err) => console.error(err));
        } else {
          setSnack({
            open: true,
            message:
              commonStrings.fileTypeError,
            severity: "error",
          });
        }
        // setDisableUploadBtn(false);
      })
      };
  const handleDownload = async (item) => {
    try {
      // let response = await poDocumentsUpload({
      //   type: "downloadDocument",
      //   file_name: fileName,
      //   docid: docid,
      //   dispatchid: dispatchid,
      //   loggedinuserid: getCurrentUserDetails()?.id,
      // });
      let response = await getDocumentsDownload(encodeURIComponent(item.uri));
      console.log("checking the data of the item ",item)
      if (response) {
        const linkSource = `data:application/pdf;base64,${response.fileData}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = item.name;
        downloadLink.click();
        setSnack({
          open: true,
          message: commonStrings.fileDownloadSuccess,
        });
      }
    } catch (e) {
      setSnack({
        open: true,
        message: commonStrings.serverError, //e.response?.data
        severity: commonStrings.error,
      });
    }
  };

  function getalltableData(data) { }

  return (
    <form className={classes.root} noValidate autoComplete="off">
      {showSnack.open && (
        <Snackbar
          {...showSnack}
          handleClose={() =>
            setSnack({ open: false, message: "", severity: "" })
          }
        />
      )}

      <ContentTabs
        value={tabId}
        onChange={(tabId) => navigate(`/certification/${certificationId}/view?tab=${tabId}`)}
      >
        <Tab label="Certification Information" index="details" visible={true}>
          <Card className="page-header">
            <CardHeader title="Certification Details" className="cardHeader" />
            <CardContent>
              <Grid container md={12}>
                <Grid item md={3} xs={12}>
                  <Typography variant="h7">{certificationView.certification_id}</Typography>
                  <Typography>{certificationId ?? "-"}</Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Grid id="top-row" container>
            <Grid item md={12} xs={12}>
              <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Grid id="top-row" container style={{ margin: 6 }}>
                    <Grid item md={12} xs={12} className="item">
                      <Typography>{certificationSections.system_info}</Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid id="top-row" container>
                    <Grid
                      id="top-row"
                      xs={12}
                      md={6}
                      container
                      direction="column"
                    >
                      <Template payload={payload1} />
                    </Grid>
                    <Grid
                      id="top-row"
                      xs={12}
                      md={6}
                      container
                      direction="column"
                    >
                      <Template payload={payload2} />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Grid id="top-row" container style={{ margin: 6 }}>
                    <Grid item md={12} xs={12} className="item">
                      <Typography>{certificationSections.cert_uploaded_versions}</Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid id="top-row" container>
                    <Grid
                      id="top-row"
                      xs={12}
                      md={6}
                      container
                      direction="column"
                    >
                      <Template payload={payload3} />
                    </Grid>
                    <Grid
                      id="top-row"
                      xs={12}
                      md={6}
                      container
                      direction="column"
                    >
                      <Template payload={payload5} />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Grid id="top-row" container style={{ margin: 6 }}>
                    <Grid item md={12} xs={12} className="item">
                      <Typography>{certificationSections.cert_uploaded_versions}</Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>

                <AccordionDetails>
                  <Grid id="top-row" container>
                    <Grid
                      id="top-row"
                      xs={12}
                      md={12}
                      container
                      direction="column"
                    >
                      <Template payload={payload6} />
                    </Grid>
                    <Grid
                      id="top-row"
                      xs={12}
                      md={6}
                      container
                      direction="column"
                    >
                      {/* <Template payload={payload5} /> */}
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Grid
                id="top-row"
                container
                spacing={24}
                justify="center"
                alignItems="center"
                style={{ margin: 24 }}
              >
                <Grid item>
                  {![
                    roles.Auditor,
                    roles.productionplanning,
                    roles.factorymanager,
                    roles.managerfinance,
                    roles.executiveLeadership,
                    roles.viewOnly,
                    roles.readOnly,
                    roles.Chairman,
                    roles.ceo,
                    roles.BusinessDevelopmentManager,
                    roles.BDDomestic,
                    roles.BDManager,
                    roles.BusinessDevelopmentHod,
                    roles.marketingExecutive,
                    roles.RDManagerBD,
                    roles.BusinessDevelopmentExecutive
                  ].includes(role) &&
                certificationDetails?.status &&  <Button
                    label="Edit" 
                    disabled = {(certificationDetails?.status === "Expired") ?true:false}
                    onClick={() =>
                      navigate(routeBuilder("certification", certificationId, "edit"), {
                        replace: true,
                      })
                    }
                  />}
                </Grid>

                <Grid item>
                  <Button label="Cancel" 
                  // onClick={() => navigate(-1)}
                  onClick={() =>
                    navigate("/certification", { replace: true })
                  }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Tab>
        <Tab label="Audit Log" index="activity" visible={true}>
          <AuditLog data={auditLogs} />
        </Tab>
        <Tab label="Notes" index="notes" visible={true}>
          <Grid container direction="row">
            <NoteList sampleId={certificationId} setNotes={setNotes} notesById={notes} />
            {notes?.length ? "" : "No Notes to display"}
          </Grid>
        </Tab>
        <Tab label="Attachments" index="attachments" visible={true}>
          {(![roles.Auditor].includes(role)) && (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <AButton
                label=""
                variant="contained"
                component="label"
                className={classes.button}
              >
                {attachmentsStrings.attach} <span class="material-icons">{attachmentsStrings.attachFile}</span>
                <input
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleFileInput}
                />
              </AButton>
              {selectedFile?.name || attachmentsStrings.noFile}
            </Grid>
            <Grid item xs={6} className="upload-btn">
              <Grid item>
                <AButton
                  disabled={disableUploadBtn}
                  label=""
                  variant="contained"
                  component="label"
                  className={classes.button}
                >
                  {attachmentsStrings.upload} &nbsp; <span class="material-icons">{attachmentsStrings.cloudUpload}</span>
                  <button
                    type="button"
                    style={{ display: "none" }}
                    onClick={(e) => uploadFile(selectedFile)}
                  >
                    {" "}
                    {attachmentsStrings.UploadToS3}
                  </button>
                </AButton>
              </Grid>
              <Grid item>
                <Button
                  label="Cancel"
                  variant="contained"
                  className={classes.button}
                  onClick={(e) => {
                    setSelectedFile(null);
                    setDisableUploadBtn(true);
                  }}
                ></Button>
              </Grid>
            </Grid>
          </Grid>
          )}
          <Grid md={12} xs={12} className="my-15">
            <FiltersTable alltableData={getalltableData} columns={antColumns} tableData={allData} />
          </Grid>
        </Tab>
      </ContentTabs>
    </form>
  );
};
export default ViewCertification;
